import TeamPitchers from "./TeamPitchers";

export default TeamPitchers;
